var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsLow24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 2C6.72715 2 2.25 6.47715 2.25 12C2.25 17.5228 6.72715 22 12.25 22C17.7728 22 22.25 17.5228 22.25 12C22.25 9.34784 21.1964 6.8043 19.3211 4.92893C17.4457 3.05357 14.9022 2 12.25 2ZM12.25 17C11.6977 17 11.25 16.5523 11.25 16C11.25 15.4477 11.6977 15 12.25 15C12.8023 15 13.25 15.4477 13.25 16C13.25 16.5523 12.8023 17 12.25 17ZM12.25 14C12.8023 14 13.25 13.5523 13.25 13V8C13.25 7.44772 12.8023 7 12.25 7C11.6977 7 11.25 7.44772 11.25 8V13C11.25 13.5523 11.6977 14 12.25 14Z",
    fill: "#FFB726"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsLow24);
export default __webpack_public_path__ + "static/media/severity-icons-low-24.e18a85117048733ca98dbbfc532d8c44.svg";
export { ForwardRef as ReactComponent };